<template>
  <v-form ref="fm_pac_info">      
      <v-card outlined tile elevation="2" class="mt-2">
          <v-card-title class="font-weight-light mb-2 pb-0">MEA-PAC & NEA Fund for Children and Public Education</v-card-title>
          <v-card-text>
            <v-row>                
                <v-col cols="12" class="py-0">
                    <p class="mb-0 mt-2 font-weight-light">CONTINUING AFFIRMATIVE CONSENT AUTHORIZATION</p>
                    <small>All education decisions are political decisions. That's why many MEA members make voluntary contributions to MEA-PAC and the NEA Fund, which are used to support pro-public education candidates (your dues dollars cannot be and are not used for contributions to political candidates).</small>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <div>Would you like to make voluntary contributions to MEA-PAC & NEA Fund for Children and Public Education?<span class="required red--text"> *</span><br/><small><strong>This optional contribution is <u>not related</u> to MEA membership/dues.</strong></small></div>
                    <v-radio-group ref="oma_mea_pac_contribution_ind" v-model="oma_mea_pac_contribution_ind" row dense class='mt-0' :rules="rules.oma_mea_pac_contribution_ind">
                        <v-radio
                            value="1"
                            label="Yes"
                        ></v-radio>
                        <v-radio
                            value="0"
                            label="Not at this time"
                        ></v-radio>
                    </v-radio-group>
                </v-col>
            </v-row>
            <v-radio-group v-if="oma_mea_pac_contribution_ind == 1" v-model="oma_mea_pac_option" :rules="[rules__oma_mea_pac_option]" dense hide-details>
                <p class='font-weight-light'>Please select a contribution amount:</p>
                <v-simple-table dense>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th></th>
                                <th class="text-left">
                                    MEA-PAC
                                </th>
                                <th></th>
                                <th class="text-left">
                                    NEA Fund
                                </th>
                                <th></th>
                                <th class="text-left">
                                    Total Contribution
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class='pr-0'>
                                    <v-radio value="suggested" label="Suggested"></v-radio>
                                </td>
                                <td>${{pac.suggested.mea}}</td>
                                <td>+</td>
                                <td>${{pac.suggested.nea}}</td>
                                <td>=</td>
                                <td v-text='pac.suggested.total'></td>                            
                            </tr>
                            <tr>
                                <td class='pr-0'>
                                    <v-radio value="basic" label="Basic"></v-radio>
                                </td>
                                <td>${{pac.basic.mea}}</td>
                                <td>+</td>
                                <td>${{pac.basic.nea}}</td>
                                <td>=</td>
                                <td v-text='pac.basic.total'></td>
                            </tr>
                            <tr>
                                <td class='pr-0'>
                                    <v-radio value="custom" label="Custom"></v-radio>
                                </td>
                                <td width="100px"><v-text-field ref="cst_pac_mea" :disabled="oma_mea_pac_option!='custom'" v-model="cst_pac_mea" type='number' hide-spin-buttons min="0" hint="custom amt" :rules="[rules__cst_pac_mea]" persistent-hint dense></v-text-field></td>
                                <td>+</td>                            
                                <td width='100px'><v-text-field ref="cst_pac_nea" :disabled="oma_mea_pac_option!='custom'" v-model="cst_pac_nea" type='number' hide-spin-buttons min="0" hint="custom amt" :rules="[rules__cst_pac_nea]" persistent-hint dense></v-text-field></td>
                                <td>=</td>
                                <td>${{cst_pac_total}} (${{round(cst_pac_total/12)}} per month for 12 months)</td>
                            </tr>                            
                        </tbody>
                    </template>
                </v-simple-table>
            </v-radio-group>      
          </v-card-text>
      </v-card> 
      <v-row class="justify-center">
          <v-col cols="12" class="d-flex flex-column flex-md-row justify-space-between">
              <v-btn
                  color="grey darken-3"
                  tile
                  @click="$emit('go-back')"
                  dark
                  class='my-2'
              >
                  Go Back
              </v-btn>

              <v-btn
                  color="rgb(0 48 87)"
                  tile
                  @click="validate_and_continue"
                  dark
                  class='my-2'
              >
                  Continue to Step 5
              </v-btn>
          </v-col>
      </v-row>
      <terms-and-conditions-dialog :showDialog="show_pac_terms" :termsDetails="$store.getters.getPacTerms" @close-dialog="show_pac_terms = false;"></terms-and-conditions-dialog>
      <saving-progress-dialog :showDialog="showSavingProgress"></saving-progress-dialog>
      <error-dialog :showDialog="showError" :errorObject="errorObj" :errorIsFatal="errorIsFatal" @close-dialog="showError=false"></error-dialog>
      <errors-on-form-dialog :showDialog="showErrorsOnForm" @close-dialog="showErrorsOnForm=false;"></errors-on-form-dialog>
  </v-form>
</template>

<script>
  import axios from 'axios'
  import TermsAndConditionsDialog from './DialogComponents/TermsAndConditionsDialog.vue'
  import SavingProgressDialog from './DialogComponents/SavingProgressDialog.vue' ;
  import ErrorDialog from './DialogComponents/ErrorDialog.vue';
  import ErrorsOnFormDialog from './DialogComponents/ErrorsOnFormDialog.vue';
  import commonMixins from '@/mixins/commonMixins';
  
  export default {
    components: { TermsAndConditionsDialog, SavingProgressDialog, ErrorDialog, ErrorsOnFormDialog },
    name: 'PacInfo',
    mixins:[commonMixins],
    data:() => ({
        showSavingProgress: false,
        showErrorsOnForm:false,
        errorObj: {},
        showError: false,
        errorIsFatal:false,
        cst_pac_total: 0,
        show_pac_terms:false,        
        pac: {
            suggested:{mea:95, nea:25, total:'$120 ($10 per month for 12 months)'},
            basic:{mea:50, nea:10, total:'$60 ($5 per month for 12 months)'}
        },
        rules:{
            oma_mea_pac_contribution_ind:[
                v => !!v || 'This field is required',
                v => /^[01]$/.test(v) || 'Option is invalid'
            ]
        }
    }),
    methods:{
        round(num){
            return Math.round(num * 100) / 100;
        },
        rules__oma_mea_pac_option(v){
            if(this.oma_mea_pac_contribution_ind == '0') return true;
            if(!v) return false;
            return /^[A-z_]+$/.test(v);        
        },
        rules__cst_pac_nea(v){
            if(this.oma_mea_pac_contribution_ind == '0') return true;
            if(this.oma_mea_pac_option != 'custom') return true;
            if(!v) return 'Required';
            return /^\d+(?:.\d{2})?$/.test(v) ?? 'Invalid';
        },
        rules__cst_pac_mea(v){
            if(this.oma_mea_pac_contribution_ind == '0') return true;
            if(this.oma_mea_pac_option != 'custom') return true;
            if(!v) return 'Required';
            return /^\d+(?:.\d{2})?$/.test(v) ?? 'Invalid';
        },        
        determine_cst_total(){
            const mea = this.cst_pac_mea??0;
            const nea = this.cst_pac_nea??0;
            this.cst_pac_total = parseInt(mea) + parseInt(nea);
        },
        async validate_and_continue(){
            if(!this.$refs.fm_pac_info.validate()){                
                this.showErrorsOnPage = true;                
                return false;
            }           

            this.showSavingProgress = true;

            // get all the form data to update the db
            const formData = {
                doCmd: 'update_db',
                app_id: window.sessionStorage.getItem('appID'),
                oma_mea_pac_option : this.oma_mea_pac_option,
                cst_pac_mea: this.cst_pac_mea,
                cst_pac_nea : this.cst_pac_nea,
                oma_nea_fund: this.oma_nea_fund,
                oma_mea_pac: this.oma_mea_pac,
                oma_mea_pac_contribution_ind: this.oma_mea_pac_contribution_ind
            }
            this.log_activity(`Attempting to update database with pac info`);

            const update_db = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify(formData), {
                headers : {'Content-Type': 'application/json'}
            });

            if(update_db.data.result.has_error){
                this.showError = true;
                let errors = [];
                update_db.data.result.fail.forEach(v => errors.push(`REF# ${v.errorref} - ${v.errortext} <br/>`))
                this.errorObj = {errorref:false, errortext:errors.join('')};
                this.errorIsFatal = false;
                this.showSavingProgress = false;
                return;
            }

            if(update_db.data.error > 0){
                this.showError = true;
                this.errorObj = {errorref:update_db.data.errorref, errortext:update_db.data.errortext};
                this.errorIsFatal = false;
                this.showSavingProgress = false;
                return;
            }
            
            const update_step_payload = {doCmd:'update_app_step', app_id: window.sessionStorage.getItem('appID'), number: 4 };
            const update_app_step = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify(update_step_payload), {
                headers : {'Content-Type': 'application/json'}
            });

            const {data: {error:uas_error, errortext:uas_errortext}} = update_app_step;
            if(uas_error > 0){
                this.showError = true;
                this.ErrorObj = {error:uas_error, errortext:uas_errortext};
                this.errorIsFatal = false;
            }

            this.showSavingProgress = false;
            this.$emit('next-step');
        },       
    },    
    
    computed:{
        oma_mea_pac_option:{
            get(){
                return this.$store.state.oma_mea_pac_option;
            },
            set(value){
                this.$store.state.oma_mea_pac_option = value;
            }
        },
        cst_pac_mea:{
            get(){                
                return this.$store.state.cst_pac_mea;
            },
            set(value){
                this.$store.state.cst_pac_mea = value;
            }
        },
        cst_pac_nea:{
            get(){
                return this.$store.state.cst_pac_nea;
            },
            set(value){                
                this.$store.state.cst_pac_nea = value;
            }
        },
        oma_mea_pac_contribution_ind:{
            get(){                
                return this.$store.state.oma_mea_pac_contribution_ind;
            },
            set(value){
                this.$store.state.oma_mea_pac_contribution_ind = value;
            }
        }
    },
    watch:{
        cst_pac_mea(){
            this.determine_cst_total();
        },
        cst_pac_nea(){
            this.determine_cst_total();
        },
        oma_mea_pac_option(val){
            if(val !='custom' && val != null){
                this.oma_mea_pac = this.pac[val].mea;
                this.oma_nea_fund = this.pac[val].nea;
                this.oma_pac_total = this.pac[val].mea + this.pac[val].nea;

                this.cst_pac_mea = null;
                this.cst_pac_nea = null;

                this.update_app_record('oma_mea_pac');
                this.update_app_record('oma_nea_fund');
                this.update_app_record('oma_pac_total');
            }
        },
        oma_mea_pac_contribution_ind(val){
            if(val == '0'){
                this.oma_mea_pac_option = null;
                this.oma_mea_pac = null;
                this.oma_nea_fund = null;
                this.oma_pac_total = null;

                this.cst_pac_mea = null;
                this.cst_pac_nea = null;

                this.update_app_record('oma_mea_pac_option');
                this.update_app_record('oma_mea_pac');
                this.update_app_record('oma_nea_fund');
                this.update_app_record('oma_pac_total');
            }
        },
        cst_pac_total(){
            this.update_app_record('cst_pac_total');
        }
    }
  }
</script>

<style scoped>

</style>